import {allWorkoutsOverviewModule} from "../modules/all-workouts-overview.module";
import {mssWorkoutsModule} from "../modules/mss-workouts.module";
import workoutsGeneralFiltersModule from "../modules/workouts-general-filters.module";
import {workoutsModule} from "../modules/workouts.module";
import {mssWorkoutsInZoneModule} from "../modules/mss-workouts-in-zone.module";
import {allWorkoutsModule} from "../modules/all-workouts.module";

class WorkoutsStoreManager
{
    backToDefault()
    {
        workoutsGeneralFiltersModule.reset();
        allWorkoutsOverviewModule.initialize(allWorkoutsModule.workouts);
    }

    applyFilters()
    {

        const {workoutEquipments, workoutFitnessCategories } = workoutsModule;

        const { workoutFitnessTypes } = allWorkoutsModule

        const {fitnessCategoryFilters, fitnessTypeFilters, typeFilters, durationFilters, trainerFilters, searchPhraze, equipmentFilters, intensityFilters, bodyPartFilters} = workoutsGeneralFiltersModule;

        const {workouts} = allWorkoutsModule;

        allWorkoutsOverviewModule.changePage(1);
        allWorkoutsOverviewModule.applyFilters({
            workouts,
            workoutEquipments,
            workoutFitnessCategories,
            workoutFitnessTypes,
            fitnessTypeFilters,
            typeFilters,
            fitnessCategoryFilters,
            durationFilters,
            trainerFilters,
            equipmentFilters,
            intensityFilters,
            searchPhraze,
            bodyPartFilters
        });
    }

    deleteEgymTrainings() {
        mssWorkoutsModule.deleteEgymTrainings();
        mssWorkoutsInZoneModule.deleteEgymTrainings();
    }
}

export default new WorkoutsStoreManager();